import React from "react";
import HeroSection from "../components/HeroSection";
import CategorySection from "../components/CategorySection";
import FeaturedSection from "../components/Featured/FeaturedSection";
import VideoSection from "../components/Video/VideoSection";
import WhyUs from "../components/WhyUs";
import DownloadSection from "../components/DownloadSection/DownloadSection";
import BlogSection from "../components/BlogSection/BlogSection";
import LearnSection from "../components/LearnSection";
import PartnersSectopn from "../components/PartnersSection";
const Home = ({ homeData }) => {
  return (
    <div>
      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <VideoSection videoData={homeData} />
      <WhyUs />
      <DownloadSection brochureData={homeData} />
      <BlogSection />
      <LearnSection />
      <PartnersSectopn />
    </div>
  );
};

export default Home;
